const defaults = require('./defaults');

const { elastic } = defaults;

module.exports = {
  ...defaults,
  mode: 'production',
  urlRoot: 'https://staging.ls-www.localsearch.cloud',
  serviceApiRoot: 'https://staging.services.lsapis.com.au',
  serviceGraphqlRoot: 'https://staging.services.lsapis.com.au/graphql',
  imageResizeRoot: 'https://dkw8fcvpqki80.cloudfront.net',
  addABusinessRoot: 'https://staging.ls-digital-presence.localsearch.cloud/',
  filemakerApiRoot:
    'https://fmwdz3tq57.execute-api.ap-southeast-2.amazonaws.com/staging',
  token: {
    ...defaults.token,
    cookie: { domain: '.localsearch.cloud' },
  },
  auth: {
    ...defaults.auth,
    redirectUri: 'https://staging.ls-www.localsearch.cloud/login-loader',
    returnTo: 'https://staging.ls-www.localsearch.cloud',
  },
  elastic: {
    ...elastic,
    node:
      'https://vpc-ls-services-staging-lr6p57o4tb22vihz46cv4x645i.ap-southeast-2.es.amazonaws.com',
  },
  deploy: {
    domain: 'staging.ls-www.localsearch.cloud',
    aliases: 'staging.ls-www.localsearch.cloud',
    certificateArn:
      'arn:aws:acm:us-east-1:789417954668:certificate/bae9ed63-b36d-478f-8684-1d8066162fc0',
    legacyBucket: 'wwwresource.localsearch.com.au.s3.amazonaws.com',
    webAcl:
      'arn:aws:wafv2:us-east-1:789417954668:global/webacl/ls-web-react-development/dd0deeb0-39f8-46ea-9a5b-47f12c4ee637',
    logBucket: 'ls-web-react-logs-dev',
    vpcSubnetIds: ['subnet-46f3a921', 'subnet-b49d4bec', 'subnet-5b93c412'],
    vpcSecurityGroupIds: ['sg-42d09625'],
  },
};
